import { CompanyId } from "@custom-types/base-types";
import { VPM_COMPANY_SUB_IDS_SET } from "@src/constants/subscription-constants";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { DateTimeUtils } from "@stellar/utils";

/**
 * Returns whether the subscription is a trial
 */
export function isTrialSubscription(
  subscription?: FaroCoreApiTypes.XGCompanySubscription
): boolean {
  if (!subscription || !subscription.label) {
    return false;
  }
  return subscription.label.toLowerCase().includes("trial");
}

/** Gets the subscription remaining days. If subscription is not available, it returns null */
export function getSubscriptionRemainingDays(
  subscription?: FaroCoreApiTypes.XGCompanySubscription
): number | null {
  return subscription?.endDate
    ? DateTimeUtils.diffFromTodayInDays({
        date: subscription.endDate,
        shouldIncludeToday: false,
      })
    : null;
}

/**
 * Since there is currently no reliable way to identify VPM subscriptions from the subscription data,
 * we maintain a list of known subscription IDs that correspond to VPM subscriptions.
 * To make it harder in the client to identify the company id, we only store the first 2 characters
 * and the last 4 characters of the subscription ID.
 * This should be unique enough to identify the subscription, but not easily reversible to get the full ID.
 * TODO: Once the VPM_COMPANY_SUB_IDS_SET is empty, remove this workaround.
 */
export function isCompanyIdFromVPMList({
  companyId,
}: {
  companyId: CompanyId | null;
}): boolean {
  const FIRST_PART_LENGTH = 2;
  const SECOND_PART_LENGTH = 4;
  if (!companyId) {
    return false;
  }
  const firstPart = companyId.slice(0, FIRST_PART_LENGTH);
  const secondPart = companyId.slice(companyId.length - SECOND_PART_LENGTH);
  return VPM_COMPANY_SUB_IDS_SET.has(`${firstPart}-${secondPart}`);
}
